import { fork, call } from "redux-saga/effects";

import { actions } from "domain/customer";
import { itemNavigator, loadSingleData } from "sagas/common";

// Store original features for comparison
let originalFeatures = [];

export default function* navigator(args) {
  yield call(loadSingleData, {
    modelName: "SeatTypes",
    actions: actions,
    id: 1,
    initForm: false,
  });
  yield fork(
    itemNavigator,
    {
      modelName: "Customer",
      actions,
      editableFields: [
        "configuration",
        "trialRemaining",
        "freeRtvPurchaseCount",
        ({ enterprise }) => ({ enterprise: enterprise?.id || null }),
        "seatTypeId",
        ({ features }) => {
          // Store original features on form init
          if (features) {
            originalFeatures = features.reduce((acc, f) => {
              acc[f.id] = f.enabled;
              return acc;
            }, {});
          }

          return {
            features: features?.map((f) => ({
              featureId: f.id,
              enabled: f.enabled,
            })),
          };
        },
      ],
      beforeSubmit: (formData) => {
        // Only include changed features
        if (formData.features && Object.keys(originalFeatures).length > 0) {
          const changedFeatures = formData.features.filter((formFeature) => {
            const originalEnabled = originalFeatures[formFeature.featureId];
            const hasChanged = originalEnabled !== formFeature.enabled;

            return hasChanged;
          });

          return { ...formData, features: changedFeatures };
        }

        return formData;
      },
    },
    args
  );
}
